export function setShops(_shopInfos){
    localStorage.setItem('hc_shopInfos', JSON.stringify(_shopInfos));
}

export function getShops () {
    return JSON.parse(window.localStorage.getItem('hc_shopInfos'));
}

export function clearCacheData () {
    window.localStorage.clear();
    window.sessionStorage.clear();
}

export function setCurrentShop (_currentShopInfo) {
    window.localStorage.setItem('hc_currentShopInfo', JSON.stringify(_currentShopInfo));
}

export function getData(key) {
    return JSON.parse(window.localStorage.getItem(key));
}

export function getCurrentShop() {
    let _shop = JSON.parse(window.localStorage.getItem('hc_currentShopInfo'));
    if (!_shop) {
        return {
            shopId: '-1',
            shopName: '未知'
        };
    }
    return _shop;
}

export function getShopId(){
    let _shop = getCurrentShop();
    if(!_shop){
        return "";
    }
    return _shop.shopId
}

/**
* Deep copy a JavaScript object.
* @param {Object} srcObj - The source object to be deep copied.
* @param {Object} targetObj - The target object to merge the copied properties into.
* @returns {Object} A deep copy of the object or the merged target object.
*/
export function deepCopy(srcObj, targetObj = {}) {
    if (srcObj === null || typeof srcObj !== 'object') {
        return srcObj;
    }
    let copy = targetObj || (Array.isArray(srcObj) ? [] : {});
    for (let key in srcObj) {
        if (Object.prototype.hasOwnProperty.call(srcObj, key)) {
            copy[key] = deepCopy(srcObj[key], copy[key]);
        }
    }
    return copy;
}

/**
 * Check if a value is a valid date.
 * @param {*} value - The value to check.
 * @returns {boolean} True if the value is a valid date, false otherwise.
 */
export function isDate(value) {
    return value instanceof Date && !isNaN(value.getTime());
}

export function copyObject (org, dst) {

    if (!org || !dst) {
        return;
    }
    //for(key in Object.getOwnPropertyNames(dst)){
    for (let key in dst) {
        if (Object.prototype.hasOwnProperty.call(org, key)) {
            dst[key] = org[key]
        }
    }
}